const API_BASE_URL = import.meta.env.VITE_BASE_URL_CAMPAIGN;

export interface Campaign {
    id: string;
    banner_url: { [key: string]: string };
    name: { [key: string]: string };
    is_active: boolean;
    title: { [key: string]: string };
    description: { [key: string]: string };
    reward_pools: object;
    notes: { [key: string]: string };
    instruction: object;
    priority: number;
    app_type: number;
    start_time: string;
    end_time: string;
    created_at: string;
    updated_at: string;
}

export interface CampaignTask {
    id: string;
    title: { [key: string]: string };
    subtext: object;
    button_text: { [key: string]: string };
    description: { [key: string]: string };
    headline: object;
    campaign_id: string;
    priority: number;
    type: number;
    task_params: {
        amount_reward: string;
        threshold: number;
        token_reward: string;
        milestone?: boolean;
    };
    created_at: string;
    updated_at: string;
    icon: string;
}

export interface UserTask {
    id: string;
    wallet_address: string;
    task_id: string;
    status: number;
    progress: number;
    expected: number;
    created_at: string;
    updated_at: string;
    active: boolean;
    nonce: string;
    signature: string;
    call_data: string;
    claim_tx: string;
}

export interface CampaignResponse {
    campaign: Campaign;
    campaign_tasks: CampaignTask[];
    wallet_address: string;
    campaign_faqs: any[];
    user_tasks: UserTask[];
    task_reset: boolean;
}

export interface CampaignWithStatus {
    campaign: Campaign;
    joined: boolean;
}

export interface CampaignsResponse {
    campaigns: CampaignWithStatus[];
    total: string;
    page: number;
    page_size: number;
}

export const api = {
    joinCampaign: (campaignId: string, address: string) =>
        fetch(`${API_BASE_URL}/${campaignId}/address/${address}/join`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
        }).then((r) => r.json()),
    getCampaign: (
        campaignId: string,
        walletAddress: string
    ): Promise<CampaignResponse> =>
        fetch(`${API_BASE_URL}/${campaignId}?wallet_address=${walletAddress}`, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        }).then((r) => r.json()),
    getCampaigns: (
        appType: number,
        isActive: boolean
    ): Promise<CampaignsResponse> =>
        fetch(`${API_BASE_URL}s?app_type=${appType}&is_active=${isActive}`, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        }).then((r) => r.json()),
};
